import React from "react";
import { useDeleteRequestMutation } from "../api/starterKitApi";
import { showToast } from "../../../core/utils/alert";
import { getApiErrorMessage } from "../../../core/utils/errorHandler";

interface DeleteRequestModalProps {
  id: number | null;
  onClose: () => void;
}

const DeleteRequestModal: React.FC<DeleteRequestModalProps> = ({ id, onClose }) => {
  const [deleteRequest, { isLoading }] = useDeleteRequestMutation();

  const handleDelete = async () => {
    if (!id) return;
    try {
      const response = await deleteRequest(id).unwrap();
      if (response.success) {
        showToast({ title: "Success", text: response.message, icon: "success" });
        document.getElementById("close_delete_request")?.click();
        onClose();
      } else {
        showToast({ title: "Error", text: response.message || "Failed to delete request", icon: "error" });
      }
    } catch (error: any) {
      showToast({ title: "Error", text: getApiErrorMessage(error) || "Something went wrong", icon: "error" });
    }
  };

  return (
    <div className="modal fade" id="delete_request_modal" tabIndex={-1} aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body text-center py-5">
            <span className="avatar avatar-xl bg-transparent-danger text-danger mb-3">
              <i className="ti ti-trash-x fs-36"></i>
            </span>
            <h4 className="mb-2">Are you sure you want to delete this request?</h4>
            <p className="mb-4">You won't be able to revert this action.</p>
            <div className="d-flex justify-content-center">
              <button
                type="button"
                className="btn btn-light me-3"
                data-bs-dismiss="modal"
                onClick={onClose}
                id="close_delete_request"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger"
                disabled={isLoading}
                onClick={handleDelete}
              >
                {isLoading ? "Deleting..." : "Yes, Delete"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteRequestModal;
